// @ts-nocheck

// https://stackoverflow.com/questions/71668256/deprecation-notice-reactdom-render-is-no-longer-supported-in-react-18
import * as React from 'react';
import * as ReactDOM from 'react-dom/client';

import { Fragment, jsx, jsxs } from 'react/jsx-runtime';

//  XXX: this package needs to be declared in the local package.json, not in
//       the parent directory’s package.json, as both also refer to React,
//       which resulted in require_react and require_react2 being generated and
//       thus ReactSharedInternals was also duplicated, leading to a big complaint
//       from the React runtime when this component was used
// TODO: make one package (this one) depend on the other (in the parent directory),
//       as suggested by Copilot
import Button from 'react-bootstrap/Button';
import ToggleButton from 'react-bootstrap/ToggleButton';
import * as icons from 'react-bootstrap-icons';
import * as HtmlReactParser from 'html-react-parser';
import type {
    Field,
    RuleGroupType,
    RuleType,
} from 'react-querybuilder';
import {
    QueryBuilder,
    defaultOperators,
    formatQuery
} from 'react-querybuilder';
import { QueryBuilderBootstrap } from '@react-querybuilder/bootstrap';

// https://www.npmjs.com/package/react-bootstrap-icons
interface IconProps extends icons.IconProps {
    // Cannot use "name" as it is a valid SVG attribute
    // "iconName", "filename", "icon" will do it instead
    iconName: keyof typeof icons;
}

export const Icon = ({ iconName, ...props }: IconProps) => {
    const BootstrapIcon = icons[iconName];
    return <BootstrapIcon {...props} />;
}

window.React = React;
window.ReactDOM = ReactDOM;

window.Fragment = Fragment;
window.jsx = jsx;
window.jsxs = jsxs;

window.Button = Button;
window.Icon = Icon;
window.HtmlReactParser = HtmlReactParser;
window.ToggleButton = ToggleButton;
window.QueryBuilder = QueryBuilder;
window.QueryBuilderBootstrap = QueryBuilderBootstrap;
